import { FC, useState, useEffect, MouseEvent, Fragment } from 'react';
import { useReactiveVar } from '@apollo/client';
import styled from '@emotion/styled';
import { parse, stringify } from 'qs';
import { useLocation } from 'react-router-dom';
import {
  AppBar,
  Toolbar as _Toolbar,
  Typography,
  Select as _Select,
  withStyles,
  Button,
  Popper,
  ClickAwayListener,
  Paper,
  List,
  ListItem,
  IconButton,
} from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import qs from 'qs';
import { Organization, User } from '@kaizenplatform/intelligence-entity';

import _Spinner from '../../primitive/Spinner';
import { flexibleLayoutContainer } from '../../../styleUtility/flexibleLayout';
import theme from '../../../../theme';
import UserMenu from './UserMenu';
import {
  COLOR_MAIN,
  COLOR_MENU_BACKGROUND,
  COLOR_MENU_HEADER,
  COLOR_TEXT_MAIN,
  COLOR_TEXT_SECONDARY,
} from '../../../../theme/colors';
//import { lastAccessedOrganizationVar, availableOrganizationsVar } from '../../../../cache';
import { availableOrganizationsVar } from '../../../../cache'; // future ^^^
import globalState from '../../../../operations/commands';
import { Organization as GraqhqlOrganization } from '../../../../generated/graphql';
import KaizenLogo from '../../primitive/Icons/KaizenLogo';
import HelpMenu from './HelpMenu';
import _Announcement from './Announcement';

type Props = {
  loadingOrganization: boolean;
  organization: Organization | null;
  organizations: Organization[];
  onChangeSelectedOrganization: (queryParams: string, orgId: string) => void;
  onClickAccountSettings: () => void;
  onClickSignOut: () => void;
  user: User | null;
  isCommentBoard?: boolean;
  className?: string;
};

const Topbar: FC<Props> = ({
  loadingOrganization,
  organization,
  organizations,
  onChangeSelectedOrganization,
  onClickAccountSettings,
  onClickSignOut,
  user,
  isCommentBoard,
  className,
}) => {
  // const lastAccessedOrganization = useReactiveVar(lastAccessedOrganizationVar)!;
  const availableOrganizations = useReactiveVar(availableOrganizationsVar)!;

  //to be replaced with --- reactiveVar
  const [selectedOrganization, setOrganization] = useState(
    organization ? organization.id : organizations.length > 0 ? organizations[0].id : '',
    // lastAccessedOrganization ? lastAccessedOrganization.id : availableOrganizations.length > 0 ? availableOrganizations[0].id : '',
  );
  const [organizationOpen, setOrganizationOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const onClickOrganizationButton = (e: MouseEvent<HTMLElement>) => {
    setOrganizationOpen(true);
    setAnchorEl(e.currentTarget);
  };

  const onRequestClose = () => {
    setOrganizationOpen(false);
  };

  // to be removed
  useEffect(() => {
    organization ? setOrganization(organization.id) : null;
  }, [organization]);

  let queryParams = parse(useLocation().search.slice(1)) || {};

  const onChangeSelect = (selectedOrganizationId: string) => {
    const selectedOrganization = organizations.find((organization) => organization.id === selectedOrganizationId);
    const __future__replace__selectedOrganization = availableOrganizations.find(
      (organization) => organization.id === selectedOrganizationId,
    );

    if (
      selectedOrganization
      // __future__replace__selectedOrganization
    ) {
      queryParams['org'] = selectedOrganization.id;
      queryParams['from'] = undefined;
      queryParams['to'] = undefined;
      queryParams['goal_id'] = undefined;
      queryParams['group'] = undefined;
      queryParams['tab'] = qs.parse(location.search.slice(1)).tab;

      globalState.setLastAccessedOrganization(__future__replace__selectedOrganization!);

      onChangeSelectedOrganization(stringify(queryParams), selectedOrganization.id);
      return;
    }

    throw new Error('selected organization not found');
  };

  return (
    <Root className={className}>
      <Toolbar>
        <KaizenLogo />

        <Menus>
          {isCommentBoard ? null : loadingOrganization ? (
            <Spinner size={24} />
          ) : organizations.length > 0 ? (
            <OrganizationSelector>
              <OrganizationSelectButton onClick={onClickOrganizationButton} style={{ textTransform: 'none' }}>
                <Typography
                  style={{
                    /* Font */
                    fontWeight: 800,
                    fontSize: '12px',
                    color: COLOR_TEXT_MAIN,
                    lineHeight: '100%',
                  }}
                >
                  {organizations.find((organization) => organization.id === selectedOrganization)?.name}
                </Typography>
                {organizationOpen ? (
                  <ArrowDropUpIcon
                    style={{
                      color: COLOR_TEXT_MAIN,
                    }}
                  />
                ) : (
                  <ArrowDropDownIcon
                    style={{
                      color: COLOR_TEXT_MAIN,
                    }}
                  />
                )}
              </OrganizationSelectButton>
              <Popper open={organizationOpen} anchorEl={anchorEl} placement="bottom-end" transition disablePortal>
                <ClickAwayListener onClickAway={onRequestClose}>
                  <StyledPaper style={{ width: 320, backgroundColor: COLOR_MENU_BACKGROUND }}>
                    <Fragment>
                      <List
                        style={{
                          padding: 0,
                        }}
                      >
                        <ListItem
                          style={{
                            height: 48,
                            display: 'flex',
                            justifyContent: 'space-between',
                            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16)',
                            backgroundColor: COLOR_MENU_HEADER,
                          }}
                        >
                          <Typography
                            variant="body1"
                            style={{
                              position: 'static',
                              fontSize: 16,
                              fontWeight: 800,
                              color: COLOR_TEXT_MAIN,
                            }}
                          >
                            組織の変更
                          </Typography>
                          <IconButton onClick={onRequestClose} style={{ width: 28, height: 28 }}>
                            <CloseIcon style={{ color: COLOR_TEXT_MAIN, width: 24, height: 24 }} />
                          </IconButton>
                        </ListItem>
                      </List>
                    </Fragment>
                    <List
                      style={{
                        padding: '16px 0px 24px 0px',
                        maxHeight: 'calc(80vh - 48px)',
                        overflowY: 'auto',
                      }}
                    >
                      {organizations.map((organization) => (
                        <ListItem
                          style={listItemStyle}
                          button
                          onClick={() => {
                            globalState.setLastAccessedOrganization(organization as GraqhqlOrganization);
                            setOrganization(organization.id);
                            onChangeSelect(organization.id);

                            onRequestClose();
                          }}
                          key={organization.id}
                        >
                          <Typography style={typographyStyle}>{organization.name}</Typography>
                          {organization.id === selectedOrganization ? (
                            <CheckIcon style={{ color: COLOR_TEXT_SECONDARY }} />
                          ) : null}
                        </ListItem>
                      ))}
                    </List>
                  </StyledPaper>
                </ClickAwayListener>
              </Popper>
            </OrganizationSelector>
          ) : null}
          <Announcement />
          <Help />
          <Menu user={user} onClickSignOut={onClickSignOut} onClickAccountSettings={onClickAccountSettings} />
        </Menus>
      </Toolbar>
    </Root>
  );
};

export const TOPBAR_HEIGHT = 64;

const listItemStyle = {
  height: 48,
  display: 'flex',
  justifyContent: 'space-between',
  padding: '0px 20px',
};

const typographyStyle = {
  color: COLOR_TEXT_MAIN,
  fontSize: 14,
  fontWeight: 700,
};

const Root = styled(AppBar)({
  height: TOPBAR_HEIGHT,
  boxShadow: 'none',
});

const Toolbar = styled(_Toolbar)(
  flexibleLayoutContainer({
    justifyContent: 'space-between',
  }),
  {
    backgroundColor: COLOR_MAIN,
    height: TOPBAR_HEIGHT,
    minHeight: TOPBAR_HEIGHT,
  },
);

const Menus = styled('div')(
  flexibleLayoutContainer({
    alignItems: 'center',
  }),
  {},
);

const Spinner = styled(_Spinner)({
  color: 'white',
});

const OrganizationSelector = styled('div')(
  flexibleLayoutContainer({
    alignItems: 'center',
  }),
);

const OrganizationSelectButton = withStyles({
  root: {
    background: '#FFFFFF',
    border: '1px solid #E6E7E8',
    boxSizing: 'border-box',
    borderRadius: '8px',
    height: 32,
    paddingLeft: 16,
    display: 'flex',
    justifyContent: 'space-between',
    '&:hover': {
      background: '#F5F6F7',
    },
  },
})(Button);

const StyledPaper = withStyles({
  rounded: {
    borderRadius: 0,
  },
  elevation1: {
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.16)',
  },
  [theme.breakpoints.up('sm')]: {},
})(Paper);

const Menu = styled(UserMenu)({
  marginLeft: 28,
});

const Announcement = styled(_Announcement)({
  marginLeft: 16,
});

const Help = styled(HelpMenu)({
  marginLeft: 16,
});

export default Topbar;
